import { LittleSubHeadline, NotificationText } from "../typography";
import closeIcon from "../../assets/images/icons/close-icon.svg";
import styled, { css } from "styled-components";
import { COLORS } from "../../assets/utils/enums/colors";
import { CopyButton } from "./button";

const ErrorBlock = ({ errorText }: { errorText: string }) => {
  return (
    <ErrorText className="d-flex align-items-center gap-1">
      <img src={closeIcon} alt="close-icon" />
      <NotificationText>{errorText}</NotificationText>
    </ErrorText>
  );
};

export default ErrorBlock;

export function LinkText({
  mainText,
  addText,
  attribute
}: {
  mainText: string;
  addText: string;
  attribute?: string;
}) {
  if (!mainText || !addText)
    return <LittleSubHeadline>Відсутні дані</LittleSubHeadline>;
  return (
    <span className={`d-flex ${mainText !== addText && !attribute ? "flex-column" : "flex-row"} ${attribute ? "gap-2" : ""}`}>
      <LittleSubHeadline className="">{mainText}</LittleSubHeadline>
      <span className="d-flex align-items-center">
        {mainText !== addText && (
          <LinkTextSt
            onClick={async () => {
              try {
                await navigator.clipboard.writeText(addText);
              } catch (err) {
                console.error("Failed to copy text: ", err);
              }
            }}
          >
            ({addText})
          </LinkTextSt>
        )}
        <CopyButton text={addText} />
      </span>
    </span>
  );
}

export const linkText = css`
  padding-bottom: 0 !important;
  /* margin-left: 6px; */
  color: ${COLORS.blue} !important;
  cursor: pointer;
  text-decoration: none;
  background-image: linear-gradient(currentColor, currentColor);
  background-size: 0% 1.5px;
  background-repeat: no-repeat;
  background-position: 0% 95%;
  transition: background-size 0.4s cubic-bezier(0.165, 0.84, 0.44, 1),
    transform 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);

  &:hover {
    background-size: 100% 1.5px;
  }

  &:active {
    transform: scale(0.95);
  }
`;

const LinkTextSt = styled(NotificationText)`
  ${linkText};
  white-space: nowrap;
`;

const ErrorText = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  background-color: transparent;
  padding: 0;
  padding-left: 20px;
  padding-top: 5px;
  color: ${COLORS.warning};
`;
